import { toast } from '../../../toast/toast';
import { toastMutationError } from '../../../query/mutationToasts';
import type {
  ChatbotConfigUpdate,
  ChatbotWithIdentity,
} from '../../../types/chatbot';
import type { I18nContextValue } from '../../../types/i18nContext';

type Translate = I18nContextValue['translate'];

/** Structural mutate() surface — avoids defaulting mutate generics to unknown. */
type MutationLike<TVariables, TData = unknown> = {
  mutate: (
    variables: TVariables,
    options?: {
      onSuccess?: (data: TData) => void;
      onError?: (error: unknown) => void;
    },
  ) => void;
};

type ChatbotConfigVariables = {
  chatbot: ChatbotWithIdentity;
  updates: ChatbotConfigUpdate;
};

type ChatbotLogoVariables = {
  chatbotId: string;
  file?: File | null;
  remove?: boolean;
};

export function saveChatbotConfigUpdates(options: {
  updateChatbotMutation: MutationLike<ChatbotConfigVariables>;
  chatbot: ChatbotWithIdentity;
  updates: ChatbotConfigUpdate;
  translate: Translate;
  successKey: string;
  errorKey: string;
}): void {
  const {
    updateChatbotMutation,
    chatbot,
    updates,
    translate,
    successKey,
    errorKey,
  } = options;

  updateChatbotMutation.mutate(
    { chatbot, updates },
    {
      onSuccess: () => {
        toast.success({
          title: translate(successKey),
          description: '',
        });
      },
      onError: (error) => {
        void toastMutationError(error, translate(errorKey));
      },
    },
  );
}

export function saveChatbotLogoUpdate(options: {
  updateChatbotLogoMutation: MutationLike<ChatbotLogoVariables>;
  chatbotId: string;
  logoFile: File | null;
  removeLogo: boolean;
  translate: Translate;
}): void {
  const {
    updateChatbotLogoMutation,
    chatbotId,
    logoFile,
    removeLogo,
    translate,
  } = options;

  updateChatbotLogoMutation.mutate(
    {
      chatbotId,
      file: logoFile,
      remove: removeLogo,
    },
    {
      onSuccess: () => {
        toast.success({
          title: translate('chatbots.settings.appearance.saveSuccessTitle'),
          description: '',
        });
      },
      onError: (error) => {
        void toastMutationError(
          error,
          translate('chatbots.settings.appearance.saveErrorTitle'),
        );
      },
    },
  );
}
